module.exports = __webpack_public_path__ + "static/media/i-think-therefore-i-am.dd4d9f7b.jpg";